import { httpClient } from './httpClient';

export const loadConfigs = async (params = { langId: 1, pageSize: 1, skip: 1 }) => {
  const response = await httpClient.post('/api/Config/LoadConfigs', params);
  return response?.data ?? {};
};

export const getContactConfigs = async () => loadConfigs();
